import React from 'react'

import './LogoStyles.less'

export default () => (
  <svg
    className="align-bottom"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 17.8929C2 18.7801 2.74653 19.5 3.66667 19.5H20.3333C21.2535 19.5 22 18.7801 22 17.8929V12H2V17.8929ZM8.66667 15.6161C8.66667 15.3951 8.85417 15.2143 9.08333 15.2143H13.8056C14.0347 15.2143 14.2222 15.3951 14.2222 15.6161V16.9554C14.2222 17.1763 14.0347 17.3571 13.8056 17.3571H9.08333C8.85417 17.3571 8.66667 17.1763 8.66667 16.9554V15.6161ZM4.22222 15.6161C4.22222 15.3951 4.40972 15.2143 4.63889 15.2143H7.13889C7.36806 15.2143 7.55556 15.3951 7.55556 15.6161V16.9554C7.55556 17.1763 7.36806 17.3571 7.13889 17.3571H4.63889C4.40972 17.3571 4.22222 17.1763 4.22222 16.9554V15.6161ZM22 6.10714V7.71429H2V6.10714C2 5.21987 2.74653 4.5 3.66667 4.5H20.3333C21.2535 4.5 22 5.21987 22 6.10714Z"
      fill="#ADB5C0"
    />
  </svg>
)
